import { toast } from "react-toastify";
import { Col, Row } from "react-bootstrap";

const Toast = (props) => {
  return (
    <Row className="align-items-center p-3">
      <Col className="ml-n2">
        {props.title && <h5 className="mb-2">{props.title}</h5>}
        <span>{props.message}</span>
      </Col>
    </Row>
  );
};

export const showToast = (type, msg, title, customSettings = {}) => {
  const settings = {
    position: toast.POSITION.TOP_RIGHT,
    hideProgressBar: false,
    closeButton: true,
    autoClose: 5000,
    theme: "colored",
    ...customSettings,
  };

  const CustomToast = (
    <Toast message={msg} title={title} default={type === "default"} />
  );

  switch (type) {
    case "error":
      toast.error(CustomToast, settings);
      break;
    case "info":
      toast.info(CustomToast, settings);
      break;
    case "success":
      toast.success(CustomToast, settings);
      break;
    case "warning":
      toast.warn(CustomToast, settings);
      break;
    default:
      toast(CustomToast, settings);
      break;
  }
};
